import { render, staticRenderFns } from "./ReportTableMovements.vue?vue&type=template&id=02bdff5e&scoped=true"
import script from "./ReportTableMovements.vue?vue&type=script&lang=ts"
export * from "./ReportTableMovements.vue?vue&type=script&lang=ts"
import style0 from "./ReportTableMovements.vue?vue&type=style&index=0&id=02bdff5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bdff5e",
  null
  
)

export default component.exports